<template>
  <div class="min-h-screen flex flex-col">
    <section class="flex-1 flex flex-col items-center justify-center py-16 px-4 relative">
      <div class="logo-container mb-8" ref="logo">
        <svg class="monogram w-48 h-48" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path class="j-letter" fill="none" d="M30,20 L30,80 M20,80 L40,80" />
          <path class="b-letter" fill="none" d="M60,20 L60,80 C75,80 80,65 80,50 C80,35 75,20 60,20 M60,50 C75,50 80,50 80,50" />
          <circle class="dot" cx="50" cy="50" r="5" />
        </svg>
      </div>
      <h1 class="text-4xl sm:text-6xl font-bold text-white mb-4 text-center animate-glow">
        Jerome Brown
      </h1>
      <p class="text-xl sm:text-2xl text-gray-300 mb-2 text-center max-w-2xl">
        Product leader & builder — fintech, marketplaces, and AI products
      </p>
      <a href="mailto:jerome@jeromejbrown.com" class="text-teal-400 hover:text-teal-300 transition-all mb-8">
        jerome@jeromejbrown.com
      </a>
      <button
        @click="scrollToContent"
        class="p-3 bg-white text-gray-900 rounded-full hover:bg-teal-400 hover:text-gray-900 transition-all"
        aria-label="Scroll to projects"
      >
        <span class="fas fa-chevron-down text-lg"></span>
      </button>
    </section>

    <FintechPuzzle />

    <section class="py-12 pb-12 px-4 sm:px-6 lg:px-8 relative" ref="contentSection">
      <h2 class="text-2xl font-bold text-center text-gray-100 mb-2">Featured Products</h2>
      <p class="text-center text-gray-400 mb-2 max-w-xl mx-auto">
        Products I've built and shipped — from idea to production.
      </p>
      <p class="text-center mb-8">
        <router-link to="/projects" class="text-sm font-medium text-teal-400 hover:text-teal-300 transition-all">
          View all products <i class="fas fa-arrow-right text-xs"></i>
        </router-link>
      </p>

      <ProjectsGrid />
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';
import FintechPuzzle from './FintechPuzzle.vue';
import ProjectsGrid from './ProjectsGrid.vue';

const contentSection = ref(null);

const scrollToContent = () => {
  contentSection.value?.scrollIntoView({ behavior: 'smooth' });
};

onMounted(() => {
  gsap.to('.j-letter', { strokeDashoffset: 0, duration: 1.2, delay: 0.2 });
  gsap.to('.b-letter', { strokeDashoffset: 0, duration: 1.5, delay: 0.5 });
  gsap.to('.dot', {
    opacity: 1,
    duration: 2,
    delay: 1.8,
    repeat: -1,
    yoyo: true,
    ease: 'power1.inOut',
  });
});
</script>

<style scoped>
@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 0.8; }
  50% { transform: scale(1.2); opacity: 1; }
}

@keyframes glow {
  0%, 100% { text-shadow: 0 0 20px rgba(45, 212, 191, 0.4); }
  50% { text-shadow: 0 0 40px rgba(45, 212, 191, 0.7), 0 0 60px rgba(59, 130, 246, 0.3); }
}

.j-letter, .b-letter {
  stroke-linecap: round;
  stroke-width: 8;
}

.j-letter {
  stroke: #3B82F6;
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
}

.b-letter {
  stroke: #E5E7EB;
  stroke-dasharray: 200;
  stroke-dashoffset: 200;
}

.dot {
  fill: #10B981;
  animation: pulse 2s infinite;
}

.animate-glow {
  animation: glow 3s infinite;
}

@media (prefers-reduced-motion: reduce) {
  .animate-glow,
  .dot {
    animation: none;
  }
}
</style>
